module.exports = __webpack_public_path__ + "static/ms-icon-144x144-dbcc606e9104fef419bce6831152548a.png";